import { Fieldset } from "primereact/fieldset"
import { Job } from '../../../../AdminPortal/scenes/Job/interface'
import { Chips } from "primereact/chips"
import { Chip } from "primereact/chip"

interface PropsDefinition {
  job: Job
}

const JobContent = (props: PropsDefinition) => {
  return (
    props.job !== undefined ?
      <div className="p-fluid p-formgrid grid">
        {/* <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Created Date</div>
          <div className="font-medium">{props.job.createdDate?.substring(0, 10)}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Updated Date</div>
          <div className="font-medium">{props.job.updatedDate?.substring(0, 10)}</div>
        </div> */}
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Title</div>
          <div className="font-medium">{props.job.title}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Specialization</div>
          <div className="font-medium">{props.job.specialization}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Career Levels</div>
          <div className="font-medium" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {Array.isArray(props.job.careerLevels) && props.job.careerLevels.length > 0
              ? props.job.careerLevels.map((level: string, idx: number) => (
                <Chip key={idx} label={level} />
              ))
              : '-'}
          </div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Employment Type</div>
          <div className="font-medium">{props.job.employmentType}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Qualifications</div>
          <div className="font-medium" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {Array.isArray(props.job.qualifications) && props.job.qualifications.length > 0
              ? props.job.qualifications.map((q: string, idx: number) => (
                <Chip key={idx} label={q} />
              ))
              : '-'}
          </div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Skills</div>
          <div className="font-medium" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {Array.isArray(props.job.skills) && props.job.skills.length > 0
              ? props.job.skills.map((s: string, idx: number) => (
                <Chip key={idx} label={s} />
              ))
              : '-'}
          </div>
        </div>
        <div className="col-12">
          <div className="p-text-secondary text-sm mb-1">Description</div>
          <div className="font-medium" style={{whiteSpace: 'pre-wrap'}}>{props.job.description}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Requirements</div>
          <div className="font-medium" style={{whiteSpace: 'pre-wrap'}}>{props.job.requirements}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Years of Experience</div>
          <div className="font-medium">{props.job.yearsOfExp || '-'}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Contract Type</div>
          <div className="font-medium">{props.job.contractType}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Minimum Salary</div>
          <div className="font-medium">SGD {props.job.minSalary && props.job.minSalary.toLocaleString()}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Maximum Salary</div>
          <div className="font-medium">SGD {props.job.maxSalary && props.job.maxSalary.toLocaleString()}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Location</div>
          <div className="font-medium">{props.job.location}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Area</div>
          <div className="font-medium">{props.job.area}</div>
        </div>
        <div className="col-12 md:col-6">
          <div className="p-text-secondary text-sm mb-1">Language</div>
          <div className="font-medium">{props.job.languages}</div>
        </div>
        <div className="col-12">
          <div className="p-text-secondary text-sm mb-1">Responsibilities</div>
          <div className="font-medium">{props.job.responsibilities || '-'}</div>
        </div>
        <div className="col-12">
          <div className="p-text-secondary text-sm mb-1">Scopes</div>
          <div className="font-medium">{props.job.scopes || '-'}</div>
        </div>
      </div>
      : <>No record found.</>
  )
}

export default JobContent